<div *ngIf="countdownDisplay" class="countdown-badge">
  <div class="mini-ring">
    <svg viewBox="0 0 26 26">
      <circle class="mini-ring-bg" cx="13" cy="13" r="11"></circle>
      <circle class="mini-ring-fill" cx="13" cy="13" r="11"></circle>
    </svg>
  </div>
  <span class="countdown-text">{{ countdownDisplay }}</span>
</div>
